import { render, staticRenderFns } from "./WindowFrame.vue?vue&type=template&id=f9127a40&scoped=true&"
import script from "./WindowFrame.vue?vue&type=script&lang=js&"
export * from "./WindowFrame.vue?vue&type=script&lang=js&"
import style0 from "./WindowFrame.vue?vue&type=style&index=0&id=f9127a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9127a40",
  null
  
)

export default component.exports